import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tournament-info"
}

import {reactive} from "@vue/reactivity";
import {api} from "@/service/APIClient";
import { onMounted, ref} from "vue";
import LoaderContent from "@/components/LoaderContent.vue";
import {useRoute, useRouter} from "vue-router";
import SvgIcon from "@/components/SvgIcon.vue";
import TournamentCard from "@/components/tournaments/TournamentCard.vue";
import TournamentDTO from "@/models/TournamentDTO";
import TournamentContent from "@/components/TournamentContent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TournamentInfo',
  setup(__props) {

const loader = ref<InstanceType<typeof LoaderContent> | null>(null)
const router = useRouter();
const route = useRoute();

const state = reactive({
  tournament: null as TournamentDTO|null
});

const back = () => {
  if (window.history.state?.back) {
    router.back()
  } else {
    router.push('/')
  }
}

onMounted(async () => {
  const id = route.params.id as unknown as number
  loader.value?.load(async () => {
    state.tournament = await api.call.tournaments.get(id)
  })
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LoaderContent, {
    ref: (ref) => loader.value = ref
  }, {
    default: _withCtx(() => [
      (_unref(state).tournament)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (back()), ["prevent"])),
              class: "nav-back"
            }, [
              _createVNode(SvgIcon, { icon: "back" }),
              _cache[1] || (_cache[1] = _createTextVNode()),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('back')), 1)
            ]),
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t('tournament_description')), 1),
            (_openBlock(), _createBlock(TournamentCard, {
              item: _unref(state).tournament,
              key: _unref(state).tournament.id,
              class: "tournament-details"
            }, null, 8, ["item"])),
            _createVNode(TournamentContent, {
              tournament: _unref(state).tournament,
              class: "tournament-content"
            }, null, 8, ["tournament"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}
}

})